import React from 'react';
import logo from '../images/logo.png'
import { Link, animateScroll as scroll } from "react-scroll";
import '../styles/header.css'
const Header = () => {

    const scrollToTop = () => {
        scroll.scrollToTop();
    };

    return (
        <div className="header fixed-top ">
            <div className=" bg-transparent text-center">
                <img
                    src={logo}
                    className="navbar-brand"
                    alt="Logo"
                    onClick={scrollToTop}
                />
            </div>
            <nav className="navbar navbar-expand-lg navbar-light   ">
                <button className="navbar-toggler" type="button" data-toggle="collapse"
                    data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse navigation" id="navbarSupportedContent">
                    <ul className="navbar-nav m-auto">
                        <li className="nav-item" >
                            <Link
                                activeClass="active"
                                to="section1"
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500}
                            >
                                o mnie.
              </Link>
                        </li>
                        <li className="nav-item" >
                            <Link
                                activeClass="active"
                                to="section2"
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500}
                            >
                                projekty.
              </Link>
                        </li>
                        <li className="nav-item" >
                            <Link
                                activeClass="active"
                                to="section3"
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500}
                            >
                                kontakt.
              </Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    );
}

export default Header;